define("shared/components/shared/ui/block", ["exports", "@ember/component", "@ember/template-factory", "@ember-decorators/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class;

  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember-decorators/component",0,"@ember/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{yield}}
  {{else if child-component}}
    {{component child-component}}
  {{else}}
    {{body}}
  {{/if}}
  */
  {
    "id": "+HUacZQK",
    "block": "[[[41,[48,[30,1]],[[[1,\"  \"],[18,1,null],[1,\"\\n\"]],[]],[[[41,[33,3],[[[1,\"  \"],[46,[33,3],null,null,null],[1,\"\\n\"]],[]],[[[1,\"  \"],[1,[34,5]],[1,\"\\n\"]],[]]]],[]]]],[\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"child-component\",\"component\",\"body\"]]",
    "moduleName": "shared/components/shared/ui/block.hbs",
    "isStrictMode": false
  });

  let Block = (_dec = (0, _component2.tagName)('div'), _dec2 = (0, _component2.classNameBindings)('primaryClass'), _dec(_class = _dec2(_class = class Block extends _component.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "primaryClass", '');
    }

  }) || _class) || _class);
  _exports.default = Block;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Block);
});